import styled from 'styled-components/macro';
import { ImageStyledWrapper } from '@yme/atoms/image';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { AspectRatio } from '@yme/utils/constants';
export const AccessoryStyled = styled.div `
  position: relative;
  width: 100%;
  text-decoration: none;
  word-break: break-word;
`;
export const RemoveButton = styled.button `
  display: block;
  position: absolute;
  right: 0;
  cursor: pointer;
  top: 0;
  padding: 8px;
  border: 0;
  background-color: transparent;
`;
export const PreviewStyled = styled.div `
  background-color: ${colorCoreWhite1000};

  width: 100%;
  min-height: 100px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  aspect-ratio: ${AspectRatio.Square};

  /* Extended styles for component Image */
  ${ImageStyledWrapper} {
    display: flex;
    align-items: center;
  }
`;
